
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqzskIA1TNWyIH4Zv_45PqgsIS_45ChrogzAMkCdG5LZLC_45AcMeta } from "/codebuild/output/src305159071/src/src/pages/faq.vue?macro=true";
import { default as menuamwAdhAMVJL23PFTeytbF0ix_450CMwCfygjplsH7RTesMeta } from "/codebuild/output/src305159071/src/src/pages/menu.vue?macro=true";
import { default as indexdDkpwZsBIpCtQmzLGOFQ67u3EqW6XP5Bronm_45LhrEusMeta } from "/codebuild/output/src305159071/src/src/pages/index.vue?macro=true";
import { default as contactk_QnWnZN1T1a3A8QrLOm4HOuYfeXo3iXOPRVCDB5hJsMeta } from "/codebuild/output/src305159071/src/src/pages/contact.vue?macro=true";
import { default as tutorialpHiQ4ucCES_45deqd_45yKN5rpGGG5Hdo_N4_45uTssaDL3L8Meta } from "/codebuild/output/src305159071/src/src/pages/tutorial.vue?macro=true";
import { default as agreementbGQTHZzE9xz4N0ONC0aYRLLqYEGiAFRjvNePSzwYSukMeta } from "/codebuild/output/src305159071/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass9QSAQRLgjpQoDpJUQy1nebfgjFAKU8ZutJv4b2DLWYAMeta } from "/codebuild/output/src305159071/src/src/pages/about-pass.vue?macro=true";
import { default as indexkzIIjV7EIz2_W5mlk9dp_45t7TSCpesrDWKKNCJdV3InsMeta } from "/codebuild/output/src305159071/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93MpEl44g4QmmiZOUljKM6ykcuDSCS_BrhursHbLTuYQ4Meta } from "/codebuild/output/src305159071/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceVvTKNgbNY9vTgj0CjkHdI_459Igcz7jmMTkF1032ntEMQMeta } from "/codebuild/output/src305159071/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93NYs_45_ohNL9xscT1gbcJpwT4cKCL2uZFmrcZOro0BS8MMeta } from "/codebuild/output/src305159071/src/src/pages/notice/[id].vue?macro=true";
import { default as index8mdodeCkNZOSkaI_MdrCx7mFd3V_9fUxcF1SWcOIDRAMeta } from "/codebuild/output/src305159071/src/src/pages/coupon/index.vue?macro=true";
import { default as indexnyRdE8nGrLbmOt7elyMLXnd7zU05FRttnl8HFFBY7oUMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/index.vue?macro=true";
import { default as indexTjPEQyM8LCTTHSsORDDKQ1l338zGlIsmgKV4Y4MkAokMeta } from "/codebuild/output/src305159071/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Y1dcLmYOW6LX9qxeV6tjzBN7CGu2rlyjFg6FGiYEd5kMeta } from "/codebuild/output/src305159071/src/src/pages/parking/[id].vue?macro=true";
import { default as indexLSU90tcSbFMENnbEwWNF4WjB_ryyoQKI3AXFpGoji_sMeta } from "/codebuild/output/src305159071/src/src/pages/history/index.vue?macro=true";
import { default as index_45Zxt3zxDdV6rTLjA_m7DvJXTimKnoQOjrkpgdylY5IEMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/index.vue?macro=true";
import { default as index59K27s_45nL7Bc2F6F2wpS0qQ4EAnPEUtXz_45fMDludzowMeta } from "/codebuild/output/src305159071/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexY46RTdhhRCgZ5J2vQ_45lVI2SmyrUfsr32DmuB5mllE78Meta } from "/codebuild/output/src305159071/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviG9GXQr7U60Yf1H698WsGKYOZ9XI3Fa6jmVEeNLrWVsEMeta } from "/codebuild/output/src305159071/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editxhllw_45CBVysnqtH8S_BKOIkxl0rYYr80iMKUBZJ82_EMeta } from "/codebuild/output/src305159071/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementKhK5wsWSToNwN5074ieirS2qcoZebn_32xiwmDTgGBYMeta } from "/codebuild/output/src305159071/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexDJyyHxGzpKR9D_sNVVQ0D_45u0uFaRneA_STRAtbqlnoQMeta } from "/codebuild/output/src305159071/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dlQjOHmPBR53oJMqWssAjehQ0cIjdsWZFYV_hJroWCrIMeta } from "/codebuild/output/src305159071/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmniW_RZz9OPMFxo2LfC6wBzyzUnpNO58_455ABDcn5t0iwMeta } from "/codebuild/output/src305159071/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexcAEuly9EqMVJl4tOGXsRuSmJsDm3LrpmFZrewNq7xEMMeta } from "/codebuild/output/src305159071/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmShJYYNyzrSYC0ynIth4XHZScORkuikRNf7WSMudC9kMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmv_455SZg0S2vUYJFC3__yp55gwGKgp9rbE5pg4NdEOzjsMeta } from "/codebuild/output/src305159071/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmE2fjmGrxJS1JE2iOBEMGG1ySqtxhPzzTWxkT7qsmzXAMeta } from "/codebuild/output/src305159071/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeK8orr_45dYFFHo9QeeFHVUquz9MNoGBzsUa4RUht5pRAsMeta } from "/codebuild/output/src305159071/src/src/pages/membership/complete.vue?macro=true";
import { default as register9b26SywEbm_45sd_45d_1ipgjBBZeZAW5ph1cc72QslVlRQMeta } from "/codebuild/output/src305159071/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93iDZbOLUZbOAMt1NB1B2ISSu5mLUfFIQuqlcm48Lw_GgMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmlcgFaCnGIsjmHyksLb2bSyAwvFANoKLg4krUvsOZhT4Meta } from "/codebuild/output/src305159071/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93GKXgePwoyHoluFD3vmWrAdZV3nPgaxATs2_BLRD_45kQMMeta } from "/codebuild/output/src305159071/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexC_OdJK5uEoLiRqjvaZUTErHIX3qILcC2EIVDtLY5SXQMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codegZcEjFgxEVkcrtvDYkXQzCQyXHKXLtZzwHFsBPZLk8EMeta } from "/codebuild/output/src305159071/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeC41WFXHFocq2ugIniXb4vlKLdhrTtoizMBVRegv_45dNAMeta } from "/codebuild/output/src305159071/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeGAWU7ooIX8vvP6Cgd6DPhNBDxOtXigZympHzyhs3_NoMeta } from "/codebuild/output/src305159071/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registermKHMjTGVOskjSJvAT_45qXGiDvrjGR4Y2LM1XtTpm11voMeta } from "/codebuild/output/src305159071/src/src/pages/contact-form/register.vue?macro=true";
import { default as completexXLmob6GFmr4CI6h48t1hYCDxon6qGactLgtqdwpsrwMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index1_DZaFjqr7IKdwcSVoFYz04_45s7dDylcA3A8ZdIyn2zYMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmN4dZPE7xVBO5Z0ufvmUdfRO4bv7ccgkO0ce_CyqwtBsMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete2GGoF10XFZs_45WzEhRoeWqROJjOrn_452e1EXeShCWWMqEMeta } from "/codebuild/output/src305159071/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexwhxkKVjWD6M9Gvmi_45JML7VfbRc4XPSm_45UkYJwIwuRcEMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93wyhEBokB_Pz5FSCNzVFrTRIISlXcOy6CAPxQOcArV_45sMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete4lWnUtLAuJdMHFJ5hQS_45CFOEeYMuHUkksQ1iPVxpQksMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasNm1o47f3cxQMhEjRsKokhCqmrphZPcKAEv7Z6mF0_45AMMeta } from "/codebuild/output/src305159071/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample_45vr9Sh_45CG_45_dDpymCy_45woyrVVVGIjMVkXYRamuTka_UMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emaillIQ67Vl_ybtAbdJEyvqCiQnz3X__45pijgbR1jP0QzDtYMeta } from "/codebuild/output/src305159071/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmsnVaNSPDMs8IydqQQp30Y9vO9fyXsNPaVPE55xGgTvIMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent9KrLhWdKQHrlj_A_45TKbs9t9sEMx9tI7_45E6EMfvJK5HcMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmJ1OqUoCmJcIy49wKy3J1k_45wB99aolgJkzjlH8Yfq0yYMeta } from "/codebuild/output/src305159071/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate4QyuHelliKg_unf4iZ0UpsKPIskwMnL_QAA23XAxGN0Meta } from "/codebuild/output/src305159071/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completejYyNGNIB1is1rwFGWiR66uGv5V6aPl5QFpz2CRf5mxIMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codem42VYG3jdm54O0f_gYYUud8f1LHHK_45xuxFFvPvNVdKIMeta } from "/codebuild/output/src305159071/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhklwc26wIUfgyGoCeZZBZHlbXDXx9iU14K7dw5G2PAoMeta } from "/codebuild/output/src305159071/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias4zKQQSkMHnmv_XkF_45N3XskjmcU2bkCL5_45K6M_JwbkE8Meta } from "/codebuild/output/src305159071/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerThCboNa2kyVmdHKdaSI466Y3YNXIwc_451nBIGO_sQgpkMeta } from "/codebuild/output/src305159071/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codelo9nOyyJkwRiN581vYf8Fv5S78RSOBHINHKR31HC_uYMeta } from "/codebuild/output/src305159071/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexFULT0HKoQPELCXUllW4_iZHxGQnled_45Bm4CMHyOaOTUMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index7AJZafYMkRxQ3he6Yo8_Y8gjgz0kOx35atgL671lGPcMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexTfAWByT1Ixtx71q3d6LO3VfdUzdOmSESZCLdOaiEGH4Meta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNL1xFfk2upGsPb1H_45n4QtQXQMwtq0psgCwQLpUnaa9UMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateY9KXygKPgqJV3EWqMaC9MuIzw7E9SHYi8YRlorMMVuUMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completec9FcIUwZaRw3AA_45u_RGnIut4hayU8K2_ZXkZcPZmMl4Meta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmkLwGgFlo4_ByB24I96iP7grstnqi5f72G2cs71EuVZUMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexkCnnBIrl_aTHpqT5qmKAmk6recAvClxN3sSBBV3c9I0Meta } from "/codebuild/output/src305159071/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completea_msI177y_45xRgNN7JEFnsF_45z_6UxeFJrx7Dy3lqdecEMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatemdc5AG4GFUY49YS70H_1g_45H8XkxSZVp1xcMpu6kLJzMMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index6mifrg82h2gkrZmEBSTFXnBRSmFw7_45IpQAF1tZIXYNIMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexKrkggLp3aN5Z2zLtyZJN2eE8YYvrpObOfSDDzr2LKt4Meta } from "/codebuild/output/src305159071/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeV3KHE9AxiUDyqROE5oB9VRuJWqrRQlSZbQ8zIg8xeocMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexF9JZXu3whJWRtdixqa0z743kJiRQOBv_IZ_4Z29edvUMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code3b3NVZNhoZZGjYM6l1r3O5Hh_6mRzV1uzKyJWx7QXN8Meta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index_dk130Ne85genxTcAc0kgDHXG619eUA_45Hg2I6toEDGkMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexz_45miveIHN1DXWsat1jICtr0Rc497qguf1lwlr3V_45E0IMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexB8_45RoebWHukgoR1qX_45WSraorIkYUVlt_45_45Bp1xRcvMGEMeta } from "/codebuild/output/src305159071/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateKOhMmYzWhqFY35opOv8qbaFPYt3kQnEH_6Y61dmYo4AMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmB4zCQ4P5U26ZJMDFoKMV_JNUDhzUXTAYN_c4565INPEMeta } from "/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src305159071/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuamwAdhAMVJL23PFTeytbF0ix_450CMwCfygjplsH7RTesMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexdDkpwZsBIpCtQmzLGOFQ67u3EqW6XP5Bronm_45LhrEusMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src305159071/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src305159071/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src305159071/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src305159071/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src305159071/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index8mdodeCkNZOSkaI_MdrCx7mFd3V_9fUxcF1SWcOIDRAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexLSU90tcSbFMENnbEwWNF4WjB_ryyoQKI3AXFpGoji_sMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index59K27s_45nL7Bc2F6F2wpS0qQ4EAnPEUtXz_45fMDludzowMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexY46RTdhhRCgZ5J2vQ_45lVI2SmyrUfsr32DmuB5mllE78Meta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src305159071/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src305159071/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexcAEuly9EqMVJl4tOGXsRuSmJsDm3LrpmFZrewNq7xEMMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmv_455SZg0S2vUYJFC3__yp55gwGKgp9rbE5pg4NdEOzjsMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmE2fjmGrxJS1JE2iOBEMGG1ySqtxhPzzTWxkT7qsmzXAMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeK8orr_45dYFFHo9QeeFHVUquz9MNoGBzsUa4RUht5pRAsMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register9b26SywEbm_45sd_45d_1ipgjBBZeZAW5ph1cc72QslVlRQMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmlcgFaCnGIsjmHyksLb2bSyAwvFANoKLg4krUvsOZhT4Meta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codegZcEjFgxEVkcrtvDYkXQzCQyXHKXLtZzwHFsBPZLk8EMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeC41WFXHFocq2ugIniXb4vlKLdhrTtoizMBVRegv_45dNAMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeGAWU7ooIX8vvP6Cgd6DPhNBDxOtXigZympHzyhs3_NoMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registermKHMjTGVOskjSJvAT_45qXGiDvrjGR4Y2LM1XtTpm11voMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmN4dZPE7xVBO5Z0ufvmUdfRO4bv7ccgkO0ce_CyqwtBsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete2GGoF10XFZs_45WzEhRoeWqROJjOrn_452e1EXeShCWWMqEMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexwhxkKVjWD6M9Gvmi_45JML7VfbRc4XPSm_45UkYJwIwuRcEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete4lWnUtLAuJdMHFJ5hQS_45CFOEeYMuHUkksQ1iPVxpQksMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample_45vr9Sh_45CG_45_dDpymCy_45woyrVVVGIjMVkXYRamuTka_UMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emaillIQ67Vl_ybtAbdJEyvqCiQnz3X__45pijgbR1jP0QzDtYMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmsnVaNSPDMs8IydqQQp30Y9vO9fyXsNPaVPE55xGgTvIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent9KrLhWdKQHrlj_A_45TKbs9t9sEMx9tI7_45E6EMfvJK5HcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmJ1OqUoCmJcIy49wKy3J1k_45wB99aolgJkzjlH8Yfq0yYMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completejYyNGNIB1is1rwFGWiR66uGv5V6aPl5QFpz2CRf5mxIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codem42VYG3jdm54O0f_gYYUud8f1LHHK_45xuxFFvPvNVdKIMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhklwc26wIUfgyGoCeZZBZHlbXDXx9iU14K7dw5G2PAoMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src305159071/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerThCboNa2kyVmdHKdaSI466Y3YNXIwc_451nBIGO_sQgpkMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codelo9nOyyJkwRiN581vYf8Fv5S78RSOBHINHKR31HC_uYMeta || {},
    component: () => import("/codebuild/output/src305159071/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src305159071/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src305159071/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]